export enum UserPermissions {
  REV_REC = 'rev_rec',
  USAGE = 'usage',
  STRIPE = 'stripe',
  BILLING = 'billing',
  PARTNERS = 'partners',
}
